module.exports = __webpack_public_path__ + "img/MasterCard-Logo-1990.d4964ac9.png";